/**
 * @generated SignedSource<<c5c6b8e131bb3fcab7290ae7ad260bd8>>
 * @relayHash 4a3abd6cfd544f47c216d160f2827641
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0d2ed57683154e7f24cbe0361e2cb5fcaa0e8f8be5e0d4df291395f09fe68152

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0d2ed57683154e7f24cbe0361e2cb5fcaa0e8f8be5e0d4df291395f09fe68152",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
